export default "__VITE_ASSET__612bac20__"